import {createAction, props} from '@ngrx/store';

export const loadPendingConfigurations = createAction(
  '[Configuration] Load pending configurations',
  props<{ configurations: string[] }>()
);
